module.exports = __webpack_public_path__ + "img/icon-message.62e0b49.png";